import * as React from "react";
import styled from "styled-components";
import { RankedYearsFrame, RankedSitesFrame } from "./components";
import { useChart } from "../../../components/Reports/Utilities/hooks/useChart";
import { useUtilities } from "../../../context/reports/utilities";

const Wrap = styled.div`
  width: 100%;
`;

export const UtilitiesPortfolio: React.FC = () => {
  const [state] = useUtilities();
  const { rankedYears, rankedSites } = useChart();
  return (
    <Wrap>
      <RankedYearsFrame
        dataSource={rankedYears}
        type={state.metricsType}
        unit={state.metricsUnit}
        loading={state.metricsLoading}
      />
      <RankedSitesFrame
        dataSource={rankedSites}
        type={state.metricsType}
        unit={state.metricsUnit}
        loading={state.metricsLoading}
      />
    </Wrap>
  );
};
